import { DialogActions, DialogContent, Typography } from '@mui/material';
import { Modal } from '../../../../ui/components/pure/modal/modal.component';
import { TextButton } from '../../../../ui/components/pure/text-button/text-button.component';

export interface AddModulesModalProps {
  onDone: () => void;
}

export function AddModulesModal({ onDone }: AddModulesModalProps) {
  return (
    <Modal title="Add Modules" open={true} divider={true} maxWidth="xs">
      <DialogContent style={{ padding: '16px 24px', fontSize: '14px' }}>
        <Typography variant="body1">You&rsquo;ll need to add modules to be able to make deliveries</Typography>
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
        <TextButton color="primary" variant="outlined" onClick={onDone}>
          Acknowledge
        </TextButton>
      </DialogActions>
    </Modal>
  );
}
